export const decrypt = (encryptId) =>{
    return encryptId/786789
}

export const encrypt = (id, number) =>{
  return id * 786789
}